<div class="overflow-x-hidden">
  <h2 class="header !h-[50px] !pl-[51px] !flex !items-center">{{approvalResponses ? 'Approval Status' : 'Send for Approval'}}</h2>
  <!-- Close Icon -->
  <div style="position: absolute; top: 17px; right: 36px">
    <img
      src="assets/icons/cross-icon.svg"
      (click)="closeDialog()"
      alt="cross icon"
      class="cursor-pointer !fixed w-[17px]"
    />
  </div>

  <div
    class="px-[3.5rem] !pt-[1rem] !pb-0 flex-col justify-center items-center !mb-[30px]"
  >
    <div class="flex">
      <!-- <label class="send-to-label pt-[1rem]">Send to</label> -->
      <div class="w-[31rem]" *ngIf="!approvalResponses">
        <mat-form-field class="w-[100%] !bg-white" appearance="outline">
          <mat-label class="relative !top-[-3px]">Select Users</mat-label>
          <mat-select
            (selectionChange)="addUser($event)"
            class="relative !top-[-3px]"
          >
            <div class="flex !w-[100%]">
              <input
                class="!bg-[#F8F8F8] !px-[10px] pl-[25px] !w-[100%] h-[2.125rem]"
                placeholder="Search Users"
                [(ngModel)]="searchQuery"
                (input)="filterUsers()"
              />
            </div>
            <mat-option
              class="hover:!bg-[#fae8e1] border-b !bg-[#ffffff] "
              *ngFor="let user of userList"
              [value]="user.id"
            >
              {{ user.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Table Section -->
    <div
      *ngIf="!approvalResponses"
      style="
        max-height: calc(40vh - 140px);
        overflow-y: auto;
        overflow-x: hidden;
      "
    >
      <table>
        <thead class="sticky top-[-1px]">
          <tr class="bg-gray-100 text-gray-600 text-sm">
            <th class="px-4 py-2 text-left tableheading">Name</th>
            <th class="px-4 py-2 text-left tableheading">Email</th>
            <th class="px-4 py-2 text-left tableheading">Position</th>
            <th class="px-4 py-2 text-center tableheading">Status</th>
            <th class="px-4 py-2 text-center tableheading">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b hover:!bg-[#fdf0ec]" 
          *ngFor="let user of usersToView">
            <td class="pl-[21px] py-2">{{ user?.name }}</td>
            <td class="pl-[21px] py-2">{{ user?.email }}</td>
            <td class="pl-[21px] py-2">{{ user?.role }}</td>
            <td class="py-2 pl-[21px] border-b text-[#aaaa19] font-bold !text-center">
              <span
              [ngClass]="{'status-pending': pending === 'pending'}"
            
            >
            {{
              pending === "pending"
                ? "Pending"
                : "Received"
            }}
            </span>
            </td>
            <td
              class="pl-4 py-2 flex justify-center mt-[5px] items-center cursor-pointer"
              (click)="removeUser(user)"
            >
            <mat-icon  class="items-center justify-center !text-black hover:!text-red-600">delete</mat-icon>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="approvalResponses">
      <table>
        <thead>
          <tr class="bg-gray-100 text-gray-600 text-sm">
            <th class="px-4 py-2 text-left">Name</th>
            <th class="px-4 py-2 text-left">Email</th>
            <th class="px-4 py-2 text-left">Title</th>
            <th class="px-4 py-2 text-left">Status</th>
            <th class="px-4 py-2 text-left">Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr class="border-b" *ngIf="!approvalResponses?.length">
            <td class="px-4 py-2">{{ approvalResponses?.name }}</td>
            <td class="px-4 py-2">{{ approvalResponses?.email }}</td>
            <td class="px-4 py-2">{{ approvalResponses?.role }}</td>
            <td
              class="px-4 py-2"
            >
            <span
            [ngClass]="{
              'status-approved': approvalResponses?.status === 'approved',
              'status-pending': approvalResponses?.status === 'pending',
              'status-clarification': approvalResponses?.status === 'clarification',
              'status-rejected': approvalResponses?.status === 'rejected',
              'status-requested-changes': approvalResponses?.status === 'request-changes',
            }"
          >
            {{ approvalResponses?.status | titlecase }}
          </span>
          
            </td>
            <td
              class="px-4 py-2 flex justify-left items-center cursor-pointer"
              [innerHTML]="
                getSanitizedHtml(
                  approvalResponses?.comment
                    ? approvalResponses?.comment
                    : 'No comment'
                )
              "
            ></td>
          </tr>

          <tr class="border-b" *ngFor="let user of approvalResponses">
            <td class="px-4 py-2">{{ user?.name }}</td>
            <td class="px-4 py-2">{{ user?.email }}</td>
            <td class="px-4 py-2">{{ user?.role }}</td>
            <td
              class="px-4 py-2"
            >
            <span
            [ngClass]="{
              'status-approved':
                user?.status=== 'approved',
              'status-pending':
                user?.status=== 'pending',
                'status-rejected':
                user?.status=== 'rejected',
                'status-clarification': user?.status === 'clarification',
                'status-requested-changes': user?.status === 'request-changes',

            }"
          >
          {{ user?.status| titlecase }}
          </span>
            </td>
            <td
              class="px-4 py-2 flex justify-left items-center cursor-pointer"
              [innerHTML]="
                getSanitizedHtml(user?.comment ? user?.comment : 'No comment')
              "
            ></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Add Note Section -->
    <div *ngIf="!approvalResponses" class="p-0 m-0 !mt-[50px]">
      <label for="add-note" class="send-to-label">Comments</label>
      <app-rich-textEditor
        placeHolder=""
        (contentChange)="approverNote($event)"
        [resetEditor]="resetRichTextEditor"
        [richTextValue]="form.get('approver_note')?.value"
      ></app-rich-textEditor>
    </div>

    <!-- Action Buttons -->
    <div class="mt-6 flex justify-end ">
      <button class="close-btn" (click)="closeApproval()">Close</button>
      <button
        *ngIf="!approvalResponses"
        class="send-btn"
        (click)="sendApproval()"
      >
        Send
      </button>
    </div>
  </div>
</div>
